import { render, staticRenderFns } from "./SidebarVerifikasiDokumen.vue?vue&type=template&id=031db612&"
import script from "./SidebarVerifikasiDokumen.vue?vue&type=script&lang=js&"
export * from "./SidebarVerifikasiDokumen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports